import { AriaRouterProvider } from '@metadevprofile/ui/web';
import { HelmetProvider } from 'react-helmet-async';
import { createBrowserRouter, Outlet, useHref, useNavigate } from 'react-router';
import { RouterProvider } from 'react-router/dom';
import { AdminLayout } from '@/admin-user/layouts/admin-layout';
import { adminRouteChildren } from '@/admin-user/navigations/admin-routes';
import { AuthGuard } from '@/auth/components/auth-guard';
import { AuthLayout } from '@/auth/layouts/auth-layout';
import { authRouteChildren } from '@/auth/navigations/auth-routes';
import { NavigationProgress } from '@/common/components/navigation-progress';
import { RouteErrorBoundary } from '@/common/components/route-error-boundary';
import { ThemeProvider } from '@/common/components/theme-provider';

import { ROUTE_PREFIXES } from '@/common/constants/route-prefixes';
import { NotFoundPage } from '@/common/pages/not-found-page';
import { InstitutionLayout } from '@/institution/layouts/institution-layout';
import { institutionRouteChildren } from '@/institution/navigations/institution-routes';
import { onboardingRouteChildren } from '@/onboarding/navigations/onboarding-routes';
import { PractitionerLayout } from '@/practitioner/layouts/practitioner-layout';
import { practitionerRouteChildren } from '@/practitioner/navigations/practitioner-routes';

function RootLayout() {
  const navigate = useNavigate();

  return (
    <AriaRouterProvider navigate={(to) => navigate(to)} useHref={useHref}>
      <NavigationProgress />
      <Outlet />
    </AriaRouterProvider>
  );
}

const router = createBrowserRouter([
  {
    element: <RootLayout />,
    errorElement: <RouteErrorBoundary />,
    children: [
      {
        element: <AuthLayout />,
        children: authRouteChildren,
      },
      {
        element: <AuthGuard />,
        children: [
          { index: true, element: null },
          ...onboardingRouteChildren,
          {
            path: ROUTE_PREFIXES.practitioner,
            element: <PractitionerLayout />,
            children: practitionerRouteChildren,
          },
          {
            path: ROUTE_PREFIXES.institution,
            element: <InstitutionLayout />,
            children: institutionRouteChildren,
          },
          {
            path: ROUTE_PREFIXES.admin,
            element: <AdminLayout />,
            children: adminRouteChildren,
          },
        ],
      },
    ],
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
]);

export function App() {
  return (
    <HelmetProvider>
      <ThemeProvider>
        <RouterProvider router={router} />
      </ThemeProvider>
    </HelmetProvider>
  );
}
